module.exports = __webpack_public_path__ + "svg_80x80/android.c81aa5.svg";